module.exports = __webpack_public_path__ + "static/media/ExternalLink.f5731d7e.svg";